var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_1123_494)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1123_494",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1123_494",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1123_494",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAhpJREFUeAHt28FNw1AURNEUQgf0kkZpBSHoIYFQBegL1h4iWY8hnEheefB73JuJ5MU/HHwQQAABBBBAAAEEEEAAAQQigdPp5e799fFh61qZ+CCBfQi8vT3fX85PH1vXyuwzzVMiAUIiotkAIbO84zRCIqLZACGzvOM0QiKi2QAhs7zjNEIiotkAIbO84zRCIqLZACGzvOM0QiKi2QAhs7zjNEIiotkAIbO84zRCIqLZACGzvOM0QiKi2QAhs7zjNEIiotkAIbO84zRCIqLZACGzvOM0QiKi2QAhs7zjNEIiotkAIbO84zRCIqLZACGzvOM0QiKi2QAhs7zjNEIiotkAIbO84zRCIqLZACGzvOO0fy1kHZ5cAJquy/npuHW+8PvesWnntcsuB1HXSdcf/PObBzD9/dcB1cUy1j8FCNk+7XvNl42QcHT6Gph7ZAkhZL967/GNbHuGhmiIhmy1UkNusSFeDPd7Kd7lxTC9p/zG/fXWu/XTsO6tzG/s9i9nElKmnRBCygiUraMhhJQRKFtHQwgpI1C2joYQUkagbB0NIaSMQNk6GkJIGYGydTSEkDICZetoCCFlBMrW0RBCygiUraMhhJQRKFtHQwgpI1C2joYQUkagbB0NIaSMQNk6GkJIGYGydTSEkDICZetoCCFlBMrW0RBCygiUrbMOT64jxlvXzR6wLHNhHQQQQAABBBBAAAEEEPj7BD4BzA88KFCIkVwAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.90b6e6a522bf39195cb4c1f21832e8b8.svg";
export { ForwardRef as ReactComponent };